{
	"administrativeFee": "Customs declaration (E-3)",
	"e1CustomsFee": "E1 Custom declaration (Value over 40.000 ISK)",
	"tollkrit": "Customs credit fee",
	"importFee": "Import duties (VAT)",
	"administrativeFeeText": "Most commonly, customers pay handling fee no. 3. We suggest that you have a look at automatic payment (handling fee no. 2) here to the right.",
	"vskText": "Most products carry 24% VAT, but for more detailed information, visit the",
	"shipmentFeeText": "Shipping fees will only be applied to packages that weigh 2 kg or less and/or fit through mail slots.",
	"infoText": "This is estimated price based on the information entered and the premises the calculator uses.",
	"infoText2": "Some products carry toll and / or processing fees. Further details on the",
	"infoText3": "If content of shipment is subject to import licences, an E1 customs declaration is made and a fee of 360 ISK may be added for each extra line needed in the declaration",
	"link": "Customs website.",
	"priceInIcelandicKronurs": "Price in ISK",
	"priceOfShipment": "Price of product in ISK (product + shipping)",
	"selectOptions": {
		"1": "Customs declaration (E-3) - Do your own declaration 500 ISK. ",
		"2": "Customs declaration (E-3) - 660 ISK. registered for automatic payments",
		"3": "Customs declaration (E-3) - 990 ISK. registered for email notification",
		"4": "Customs declaration (E-3) - 1350 ISK. registered for letter notification "
	},
	"sendingFee": "Shipping fee",
	"sendingFeeEurope": "Shipping fee Europe",
	"sendingFeeOutsideEurope": "Shipping fee rest of world",
	"total": "Total",
	"totalFee": "Total fees",
	"valueAddedTax": "VAT - Charged by customs",
	"valueAddedTaxShort": "VAT",
	"breakdown": "Breakdown"
}